export default __webpack_public_path__ + "static/think-dogs-banner-bg-9e4b07cee30c359999e0ed317a4fbd35.jpg";